import { PrivacyScreen } from '@capacitor/privacy-screen';
import { Loading, Modal, Selector, Toast } from 'antd-mobile';
import axios from 'axios';
import { useI18n } from 'i18n/useI18n';
import { useEffect, useRef, useState } from 'react';
import { UserGroupDataType } from 'services/apis/usr/user-group-api';
import { payBaseUrl } from 'services/request';
import { getUrl, getVPayData } from 'utils/vPayUtils';
import { options } from '.';

const PayModal = (data: { userId: string; selectUsergroup: UserGroupDataType; closePayModel: () => void }) => {
  const { t } = useI18n();

  const [, _refreshView] = useState('');
  const payMode = useRef<string>();
  const waitTimeRef = useRef<number>(10);
  const [waitTime, setWaitTime] = useState<string>(waitTimeRef.current + t('level-info.index.180777-0'));
  const [payIframeVisible, setPayIframeVisible] = useState(false);
  const [payIframeUrl, setPayIframeUrl] = useState('');

  const [showTipModal, setShowTipModal] = useState<boolean>(false);

  const [frameUrl, setFrameUrl] = useState<string>(null);
  useEffect(() => {
    PrivacyScreen.disable();
    return () => {
      PrivacyScreen.enable();
    };
  }, []);

  // 页面内容
  return (
    <>
      <div key="payModal">
        {/* 选择支付通道 */}
        <Modal
          closeOnMaskClick={true}
          showCloseButton={false}
          visible={data.selectUsergroup != null}
          onClose={() => {
            data.closePayModel();
          }}
          content={
            <center>
              <p className=" text-lg mb-2">{' 开通 ' + data.selectUsergroup.groupName}</p>
              <p className=" text-red-500 my-2">{t('level-info.index.180777-9')}</p>
              <Selector
                columns={1}
                options={options}
                onChange={(arr, extend) => {
                  payMode.current = arr[0];
                }}
                style={{
                  '--color': '#ddd',
                  '--text-color': '#000',
                  '--border-radius': '10px',
                  '--checked-color': '#ffcccc',
                }}
              />
            </center>
          }
          actions={[
            {
              key: 'console',
              text: (
                <div style={{ textAlign: 'right' }}>
                  <span
                    style={{
                      fontSize: 16,
                      color: '#fff',
                      background: '#AA2222',
                      padding: '6px 15px',
                      borderRadius: 5,
                    }}
                    onClick={async () => {
                      if (!payMode.current && (payMode.current !== 'alipay' || 'wxpay')) {
                        Toast.show(t('level-info.index.180777-9'));
                        return;
                      } else {
                        // Toast.show("使用" + payMode.current + "支付");

                        // 创建订单倒计时
                        // let timer;
                        // if (true) {
                        //   waitTimeRef.current = 10;
                        //   setShowTipModal(true);
                        //   timer = setInterval(() => {
                        //     console.log(waitTime);
                        //     waitTimeRef.current = waitTimeRef.current - 1;
                        //     setWaitTime(waitTimeRef.current + t('level-info.index.180777-0'));
                        //     if (waitTimeRef.current === 0) {
                        //       setWaitTime(t('level-info.index.180777-11'));
                        //     }
                        //     _refreshView('');
                        //   }, 1000);
                        // }

                        // showGlobalLoading();
                        setShowTipModal(true);

                        // 请求V免签接口
                        if (true) {
                          const vPayData = getVPayData(
                            payMode.current,
                            // 毫秒时间戳:userId:usergroupId
                            // 1740467873769:_ROOT_USER_ADMIN:A1E877387CF24C8E8395EF2AB9AC8F7A
                            Date.now() + ':' + data.userId + ':' + data.selectUsergroup?.uuid,
                            // groupType:groupName
                            data.selectUsergroup.groupType + ':' + data.selectUsergroup.groupName,
                            data.selectUsergroup.discountPrice
                          );
                          console.log('支付信息：', JSON.stringify(vPayData, null, 2));
                          const config = {
                            method: 'get',
                            maxBodyLength: Infinity,
                            url: getUrl(vPayData),
                            headers: {},
                            // timeout: 10000,
                          };

                          axios
                            .request(config)
                            .then(async (response) => {
                              console.log(JSON.stringify(response.data));
                              // 无法检测到
                              if (response.data.code === -1) {
                                Toast.show(response.data.msg);
                                return;
                              }

                              const match = response.data.match(/location\.href\s*=\s*['"]([^'"]+)['"]/);
                              const payIframeUrl = payBaseUrl + match[1];

                              setTimeout(() => {
                                setShowTipModal(false);
                                setFrameUrl(payIframeUrl);
                              }, 1000 * 3);
                              return;
                            })
                            .catch((error) => {
                              Toast.show('操作失败，请联系管理员');
                              setShowTipModal(false);
                            });
                        }
                      }
                    }}
                  >
                    确定
                  </span>
                  <span
                    style={{
                      fontSize: 16,
                      color: '#333',
                      padding: '6px 15px',
                      borderRadius: 5,
                      border: '1px solid #ddd',
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      data.closePayModel();
                    }}
                  >
                    取消
                  </span>
                </div>
              ),
            },
          ]}
        />
        {/* 正在创建订单 */}
        <Modal
          visible={showTipModal}
          closeOnMaskClick={false}
          closeOnAction={false}
          showCloseButton={false}
          title={<h2 style={{ color: '#666', margin: 5 }}>{t('level-info.index.180777-5')}</h2>}
          content={
            <div className=" text-center">
              <p>{t('level-info.index.180777-6')}</p>
              <Loading
                color="#66ccff"
                className=" m-2"
              />
            </div>
          }
        />
      </div>
      {/* 支付订单 */}
      {frameUrl && (
        <div
          className=" fixed bottom-0 left-0 flex flex-col justify-start items-center"
          // Modal的zIndex为1000
          style={{ width: window.innerWidth, height: window.innerHeight, zIndex: 1001 }}
        >
          {/* 【很奇怪】如果有元素遮挡了 iframe，会导致内部无法点击 */}
          <iframe
            src={frameUrl}
            width={'100%'}
            // height={'100%'}
            sandbox="allow-same-origin allow-top-navigation	allow-forms	allow-scripts	"
            allowFullScreen={true}
            // allowTransparency={true}
            // 设置border，会导致内部无法点击
            // style={{borderRadius: 10}}
            className=" scale-90 grow"
          />
          <div
            key="cancelPay"
            className=" p-2 mb-8 text-white bg-orange-500 rounded-md shadow-md"
            onClick={() => {
              // Toast.show('取消支付');
              data.closePayModel();
              setFrameUrl(null);
            }}
          >
            取消支付
          </div>
        </div>
      )}
    </>
  );
};

export default PayModal;
